import { Col, Container, Row } from "react-bootstrap";
import React, { useState } from "react";
import "../../assets/css/loadingwrapper.css";
import "react-tabs/style/react-tabs.css";
import "../../assets/css/customCheckbox.css";
import { useSelector, useDispatch } from "react-redux";
import { myBusinessUpdate } from "../../Redux/Settings/myBusiness/actions";

const Notifications = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.authReducer.data);
  const businessData = useSelector((state) => state.myBusinessReducer.data);
  const [selectedNotifications, setSelectedNotifications] = useState({
    email: businessData?.notifications?.email || false,
    sms: businessData?.notifications?.sms || false,
  });

  const handleChange = async (event) => {
    const { name, checked } = event.target;
    const updatedNotifications = {
      ...selectedNotifications,
      [name]: checked,
    };

    setSelectedNotifications(updatedNotifications);

    const payload = {
      notifications: updatedNotifications,
    };

    await myBusinessUpdate(dispatch, user?.accountID, payload);
  };

  return (
    <Container className="mt-5 p-3">
      <Row>
        <Col>
          <div>
            <h4 className="main-h4-tag-large mb-3">
              Inbound Messages Notification
            </h4>
            <div className="d-flex ">
              <div className="cntr mr-5 d-flex align-items-center">
                <input
                  type="checkbox"
                  id="cbx-email"
                  className="hidden-xs-up"
                  name="email"
                  checked={selectedNotifications.email}
                  onChange={handleChange}
                />
                <span className="custom-p-tag mr-2">Email</span>
                <label htmlFor="cbx-email" className="cbx cbx-email"></label>
              </div>
              <div className="cntr d-flex align-items-center">
                <input
                  type="checkbox"
                  id="cbx-sms"
                  className="hidden-xs-up"
                  name="sms"
                  checked={selectedNotifications.sms}
                  onChange={handleChange}
                />
                <span className="custom-p-tag mr-2">SMS</span>
                <label htmlFor="cbx-sms" className="cbx cbx-sms"></label>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
export default Notifications;
